import { useMutation } from '@tanstack/react-query';
import axiosClient from 'api/config/axios';
import { createErrorHandler } from 'api/config/axios.errors';
import { adaptPayoutAccount } from 'api/escrow/adapters';

type Params = {
  accountType: string;
  accountName: string;
  accountNumber: string;
  channelCode?: string | null;
};

async function upsertPayoutAccount(params: Params) {
  const body: Record<string, unknown> = {
    account_type: params.accountType,
    account_name: params.accountName,
    account_number: params.accountNumber,
  };
  if (params.channelCode != null) {
    body.channel_code = params.channelCode;
  }
  const result = await axiosClient.mutate.post('/api/v1/escrow/payout-account', body);
  return adaptPayoutAccount(result.data.payout_account);
}

const mutationKey = ['escrow', 'payout-account', 'upsert'] as const;

export function useUpsertPayoutAccountMutation() {
  return useMutation({
    mutationKey,
    mutationFn: upsertPayoutAccount,
    onError: createErrorHandler('Unable to save payout account at this time.'),
  });
}
